/*!
 * ceiling.js — the very last stage of the output: nothing louder than this
 * © 2026 Rob Canning — GPLv3
 *
 * The master limiter (a DynamicsCompressor) can overshoot on a sharp
 * attack, and a wall of noise is all attack. After it, a WaveShaper with
 * this curve: the sound as it is up to `knee`, rounded off above it, never
 * past `ceil` -- whatever goes in (a WaveShaper holds its curve's ends for
 * anything beyond -1..1). 0.95 is about -0.45 dBFS.
 */

/** The curve: n points over -1..1, odd (the negative half the mirror of the positive). */
export function ceilingCurve(n = 4097, knee = 0.8, ceil = 0.95) {
  const out = new Float32Array(n), room = ceil - knee;
  for (let i = 0; i < n; i++) {
    const x = (i / (n - 1)) * 2 - 1, a = Math.abs(x);
    // above the knee: tanh into what is left of the room, so the slope is 1 at the knee
    const y = a <= knee ? a : knee + room * Math.tanh((a - knee) / room);
    out[i] = Math.sign(x) * Math.min(ceil, y);
  }
  return out;
}
